import { useMedia } from './use-media';

export const useIsMobile = () => {
  return useMedia('(max-width: 768px)');
};
